
/*
  Truncates a string to a number of characters, option to pass word consideration
  returns the truncate string + an ellipsis
*/
function truncate(n, useWordBoundary) {
  if (this.length <= n) { return this; }
  const subString = this.substr(0, n - 1);
  return `${((useWordBoundary && subString.indexOf(' ') > -1)
    ? subString.substr(0, subString.lastIndexOf(' '))
    : subString)}…`;
}

const truncateFn = (str, n, useWordBoundary) => {
  if (str.length <= n) { return str; }
  const subString = str.substr(0, n - 1);
  return `${((useWordBoundary && subString.indexOf(' ') > -1)
    ? subString.substr(0, subString.lastIndexOf(' '))
    : subString)}…`;
};

const jsonParseFn = str => {
  if (typeof str === 'object') return str;
  let result = {};
  try {
    // if plain js
    result = JSON.parse(str);
  } catch (e) {
    // forget about it :)
  }
  return result;
};

module.exports = {
  truncate,
  truncateFn,
  jsonParseFn,
};



// WEBPACK FOOTER //
// ./src/app/utils/string.js